[
  {
    "type": "function",
    "name": "initialDeposit",
    "inputs": [
      { "name": "asset", "type": "address" },
      { "name": "vault", "type": "address" },
      { "name": "amount", "type": "uint256" }
    ],
    "outputs": [],
    "stateMutability": "nonpayable"
  },
  {
    "type": "function",
    "name": "userDeposit",
    "inputs": [
      { "name": "asset", "type": "address" },
      { "name": "amount", "type": "uint256" }
    ],
    "outputs": [],
    "stateMutability": "nonpayable"
  },
  {
    "type": "function",
    "name": "withdraw",
    "inputs": [
      { "name": "asset", "type": "address" },
      { "name": "amount", "type": "uint256" }
    ],
    "outputs": [],
    "stateMutability": "nonpayable"
  },
  {
    "type": "function",
    "name": "getPortfolioSummary",
    "inputs": [],
    "outputs": [
      { "name": "assets", "type": "address[]" },
      { "name": "deposited", "type": "uint256[]" },
      { "name": "currentValues", "type": "uint256[]" },
      { "name": "profits", "type": "int256[]" },
      { "name": "activeCount", "type": "uint256" }
    ],
    "stateMutability": "view"
  },
  {
    "type": "function",
    "name": "getAssetVaultBalance",
    "inputs": [{ "name": "asset", "type": "address" }],
    "outputs": [{ "name": "", "type": "uint256" }],
    "stateMutability": "view"
  },
  {
    "type": "function",
    "name": "getAssetVaultAssets",
    "inputs": [{ "name": "asset", "type": "address" }],
    "outputs": [{ "name": "", "type": "uint256" }],
    "stateMutability": "view"
  },
  {
    "type": "function",
    "name": "getAssetProfit",
    "inputs": [{ "name": "asset", "type": "address" }],
    "outputs": [{ "name": "", "type": "int256" }],
    "stateMutability": "view"
  },
  {
    "type": "function",
    "name": "getAssetProfitPercentage",
    "inputs": [{ "name": "asset", "type": "address" }],
    "outputs": [{ "name": "", "type": "int256" }],
    "stateMutability": "view"
  },
  {
    "type": "function",
    "name": "getAllowedAssets",
    "inputs": [],
    "outputs": [{ "name": "", "type": "address[]" }],
    "stateMutability": "view"
  },
  {
    "type": "function",
    "name": "getTokenBalance",
    "inputs": [{ "name": "token", "type": "address" }],
    "outputs": [{ "name": "", "type": "uint256" }],
    "stateMutability": "view"
  },
  {
    "type": "function",
    "name": "getFeeInfo",
    "inputs": [],
    "outputs": [
      { "name": "_revenueAddress", "type": "address" },
      { "name": "_feePercentage", "type": "uint256" },
      { "name": "_rebalanceFeePercentage", "type": "uint256" },
      { "name": "_merklClaimFeePercentage", "type": "uint256" }
    ],
    "stateMutability": "view"
  },
  {
    "type": "function",
    "name": "getAssetAvailableVaults",
    "inputs": [{ "name": "asset", "type": "address" }],
    "outputs": [{ "name": "", "type": "address[]" }],
    "stateMutability": "view"
  },
  {
    "type": "function",
    "name": "owner",
    "inputs": [],
    "outputs": [{ "name": "", "type": "address" }],
    "stateMutability": "view"
  },
  {
    "type": "function",
    "name": "assetTotalDeposited",
    "inputs": [{ "name": "asset", "type": "address" }],
    "outputs": [{ "name": "", "type": "uint256" }],
    "stateMutability": "view"
  },
  {
    "type": "function",
    "name": "assetHasInitialDeposit",
    "inputs": [{ "name": "asset", "type": "address" }],
    "outputs": [{ "name": "", "type": "bool" }],
    "stateMutability": "view"
  },
  {
    "type": "function",
    "name": "assetToVault",
    "inputs": [{ "name": "asset", "type": "address" }],
    "outputs": [{ "name": "", "type": "address" }],
    "stateMutability": "view"
  },
  {
    "type": "function",
    "name": "bridgeNonce",
    "inputs": [],
    "outputs": [{ "name": "", "type": "uint256" }],
    "stateMutability": "view"
  },
  {
    "type": "function",
    "name": "assetBridgedOut",
    "inputs": [
      { "name": "asset", "type": "address" },
      { "name": "destChainId", "type": "uint256" }
    ],
    "outputs": [{ "name": "", "type": "uint256" }],
    "stateMutability": "view"
  },
  {
    "type": "function",
    "name": "assetBridgedIn",
    "inputs": [
      { "name": "asset", "type": "address" },
      { "name": "srcChainId", "type": "uint256" }
    ],
    "outputs": [{ "name": "", "type": "uint256" }],
    "stateMutability": "view"
  },
  {
    "type": "event",
    "name": "InitialDeposit",
    "inputs": [
      { "name": "asset", "type": "address", "indexed": true },
      { "name": "vault", "type": "address", "indexed": true },
      { "name": "amount", "type": "uint256", "indexed": false }
    ]
  },
  {
    "type": "event",
    "name": "UserDeposit",
    "inputs": [
      { "name": "asset", "type": "address", "indexed": true },
      { "name": "vault", "type": "address", "indexed": true },
      { "name": "amount", "type": "uint256", "indexed": false }
    ]
  },
  {
    "type": "event",
    "name": "Withdrawal",
    "inputs": [
      { "name": "asset", "type": "address", "indexed": true },
      { "name": "vault", "type": "address", "indexed": true },
      { "name": "recipient", "type": "address", "indexed": true },
      { "name": "amount", "type": "uint256", "indexed": false }
    ]
  },
  {
    "type": "event",
    "name": "BridgeWithdraw",
    "inputs": [
      { "name": "nonce", "type": "uint256", "indexed": true },
      { "name": "asset", "type": "address", "indexed": true },
      { "name": "amount", "type": "uint256", "indexed": false },
      { "name": "spent", "type": "uint256", "indexed": false },
      { "name": "bridgeRouter", "type": "address", "indexed": false },
      { "name": "destChainId", "type": "uint256", "indexed": false },
      { "name": "feeAmount", "type": "uint256", "indexed": false }
    ]
  },
  {
    "type": "event",
    "name": "BridgeDepositAcknowledged",
    "inputs": [
      { "name": "nonce", "type": "uint256", "indexed": true },
      { "name": "asset", "type": "address", "indexed": true },
      { "name": "amount", "type": "uint256", "indexed": false },
      { "name": "srcChainId", "type": "uint256", "indexed": false }
    ]
  }
]
